const InvoiceStatusEnum = {    
    Open: 'Open',
    Sent: 'Sent',
    Paid: 'Paid',
    PartiallyPaid: 'PartiallyPaid',
    Viewed: 'Viewed',
}

export default InvoiceStatusEnum;